export { default } from './LogoActivitat';
